import React from 'react';
import { SelectInput, TextInput, required } from 'react-admin';
import { Grid, Typography } from '@material-ui/core/';
import { makeStyles } from '@material-ui/core';
import { groupStatus } from './GroupLookups';
import { fieldLengthValidator } from '../../core/utils/index';

const useStyles = makeStyles({
  headerContainer: {
    paddingTop: '0px !important'
  },
  formCheckBox: {
    marginTop: '19px'
  }
});

const GroupSummary = props => {
  const classes = useStyles();

  return (
    <div>
      <Grid container spacing={2}>
        <Grid item xs={12} className={classes.headerContainer}>
          <Typography variant="h5">Group Details</Typography>
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <TextInput
            source="name"
            label="Group Name"
            validate={[required(), fieldLengthValidator(40)]}
            options={{ autoComplete: 'off' }}
            variant={props.variant}
          />
        </Grid>
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <SelectInput
            source="status"
            label="Group Status"
            choices={groupStatus}
            validate={[required()]}
            variant={props.variant}
          />
        </Grid>
        <Grid item xs={12} sm={12} lg={4} />
        <Grid item xs={12} sm={12} md={6} lg={4}>
          <TextInput
            multiline
            source="description"
            label="Group Description"
            validate={[fieldLengthValidator(1000)]}
            rows="3"
            options={{ autoComplete: 'off' }}
            variant={props.variant}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default GroupSummary;
